import styled from "styled-components";
//generics
import { IIndicatorColors } from './interface';

export const HeaderIndicatorComponent = styled.div<IIndicatorColors>`
  display: flex;
  background-color: #FFFFFF;
  min-width: 184px;
  border-left: solid 5px ${(props) => props.indicatorColor};
`;

export const HeaderIndicatorContent = styled.div<IIndicatorColors>`
  padding: 7px;
  max-width: 230px;

  h1, p{
    font-size: 12px;
  }

  h1{
    color: ${(props) => props.indicatorColor};
    font-weight: 600;
    margin-bottom: 3px;
  }

  p{
    color: #858585;
    line-height: 1;
  }
`;
